export const gridSpacing = 3;
export const drawerWidth = '280px';
export const appDrawerWidth = 320;
export const primaryColor = '#1976d2';
export const secondaryColor = '#d2197d';
export const borderRadius = '8px';